import React, { useEffect, useState } from "react";
import __ from "lodash";
import PropTypes from "prop-types";
import { useDidMount } from "../../../../hooks/useDidMountEffect";
import { REDIRECTION } from "../../../../constants/Constants";

let closeTabTimer = 0;
const RedirectionTime = ({ closeTabParams, timerCounterSecond, isPlatFormValueAvailable, isCounterTimerVisiable, localisedValues }) => {
    const [timerValue, setTimerValue] = useState(timerCounterSecond);

    /* start counter once disconnect the call */
    useEffect(() => {
        startTimerCounter();
    }, [isCounterTimerVisiable]);

    /* - handle redirection based on timer value */
    useEffect(() => {
        if (timerValue === 0) {
            if (!isPlatFormValueAvailable && __.isEmpty(closeTabParams)) {
                window.history.go(-1);
            } else {
                window.close();
            }
        }
    }, [timerValue]);

    /* - counter will be start based on interval */
    const startTimerCounter = () => {
        closeTabTimer = setInterval(() => {
            setTimerValue((prevValue) => {
                if (prevValue === 0) {
                    // Redirect logic can be implemented here if necessary
                }
                return Math.max(prevValue - 1, 0); // Ensure timerValue doesn't go below 0
            });
        }, 1000);
        return closeTabTimer;
    };

    /* - handle stop counter based on other button clicks */
    useDidMount(() => {
        clearInterval(closeTabTimer);
    }, [isCounterTimerVisiable]);

    return (
        <div className='auto-redirect-user' data-testid='redirection-time'>
            <div className='auto-redirect-user-in'>
                <div className='redirect-timer'>
                    <svg width='64' height='64' id='svgCounter'>
                        <g>
                            <circle r='16' cx='32' cy='32' strokeWidth='10'></circle>
                            <circle
                                r='16'
                                cx='32'
                                cy='32'
                                style={{
                                    strokeDasharray: `${(REDIRECTION.TIMER_MAXIMUM_VALUE / timerCounterSecond) * (timerCounterSecond - timerValue)} 314`,
                                    stroke: "var(--page_background_color)",
                                    strokeWidth: "4",
                                }}
                            ></circle>
                            <text x='50%' y='-50%' dominantBaseline='middle' textAnchor='middle' fontFamily='sans-serif' fontSize='11px'>
                                {Math.max(timerValue, 0)}
                            </text>
                        </g>
                    </svg>
                </div>
                <div className='redirect-text'>
                    {isPlatFormValueAvailable ? localisedValues?.closing_tab : localisedValues?.return_to_home_screen}
                </div>
            </div>
        </div>
    );
};

RedirectionTime.propTypes = {
    closeTabParams: PropTypes.oneOfType([PropTypes.string, PropTypes.number]),
    timerCounterSecond: PropTypes.number,
    isPlatFormValueAvailable: PropTypes.bool,
    isCounterTimerVisiable: PropTypes.bool,
    localisedValues: PropTypes.any,
};
export default RedirectionTime;
